module.exports = __webpack_public_path__ + "static/media/SourceSerifPro-Regular.67a017e4.ttf";